import {
    GET_STATE_LOADING,
    GET_SURVEYS,
    GET_CURRENT_SURVEY,
    GET_QUESTION_TYPES,
    GET_SURVEY_CONFIG,
    GET_RESPONSES,
    GET_SUMMARY,
    GET_OVERVIEW,
    GET_BOT_CONFIG
} from "@/views/surveys/store/types/types.js";

const getters = {
    [GET_STATE_LOADING]: state => state.loading,
    [GET_SURVEYS]: state => state.surveys,
    [GET_CURRENT_SURVEY]: state => state.currentSurvey,
    [GET_QUESTION_TYPES]: state => state.questionTypes,
    [GET_SURVEY_CONFIG]: state => state.surveyConfig,
    [GET_RESPONSES]: state => state.responses,
    [GET_SUMMARY]: state => state.summary,
    [GET_OVERVIEW]: state => state.overview,
    [GET_BOT_CONFIG]: state => state.botConfig
}

export default getters;
